import {DISCOUNT_TYPE} from '../constants/discountsV2';

const replaceZ = (value) => {
  return value.replace('Z', '');
};

export const discountsV2ReplaceZFromDates = (discount) => {
  const newDiscount = {...discount};

  if (
    newDiscount.availability?.activatesAtLocal &&
    newDiscount.availability.activatesAtLocal.endsWith('Z')
  ) {
    newDiscount.availability.activatesAtLocal = replaceZ(
      newDiscount.availability.activatesAtLocal
    );
  }
  if (
    newDiscount.availability?.deactivatesAtLocal &&
    newDiscount.availability.deactivatesAtLocal.endsWith('Z')
  ) {
    newDiscount.availability.deactivatesAtLocal = replaceZ(
      newDiscount.availability.deactivatesAtLocal
    );
  }

  if (
    newDiscount.promoCode?.usageLimit?.activatesAtLocal &&
    newDiscount.promoCode.usageLimit.activatesAtLocal.endsWith('Z')
  ) {
    newDiscount.promoCode.usageLimit.activatesAtLocal = replaceZ(
      newDiscount.promoCode.usageLimit.activatesAtLocal
    );
  }

  return newDiscount;
};

export const discountsV2AddZToDates = (discount) => {
  const newDiscount = {...discount};

  if (
    newDiscount.availability?.activatesAtLocal &&
    !newDiscount.availability.activatesAtLocal.endsWith('Z')
  ) {
    newDiscount.availability.activatesAtLocal = `${newDiscount.availability.activatesAtLocal}Z`;
  }
  if (
    newDiscount.availability?.deactivatesAtLocal &&
    !newDiscount.availability.deactivatesAtLocal.endsWith('Z')
  ) {
    newDiscount.availability.deactivatesAtLocal = `${newDiscount.availability.deactivatesAtLocal}Z`;
  }

  if (
    newDiscount.promoCode?.usageLimit?.activatesAtLocal &&
    !newDiscount.promoCode.usageLimit.activatesAtLocal.endsWith('Z')
  ) {
    newDiscount.promoCode.usageLimit.activatesAtLocal = `${newDiscount.promoCode.usageLimit.activatesAtLocal}Z`;
  }

  return newDiscount;
};

export const createBaseDiscount = () => ({
  name: '',
  type: null,
  rate: {
    type: null,
    value: ''
  },
  subtotal: {
    min: '',
    max: null
  },
  fulfillment: {
    types: ['Pickup', 'Delivery'],
    delivery: null
  },
  customers: {
    types: ['New', 'Returning']
  },
  availability: {
    activatesAtLocal: null,
    deactivatesAtLocal: null,
    weekly: null
  },
  isPromotional: true,
  isExclusive: false,
  promoCode: {
    code: '',
    usageLimit: null
  },
  specificItems: null,
  combo: null,
  bogo: null,
  marketing: {
    email: {
      isEnabled: false
    }
  },
  creationReason: null
});

export const getDiscountTypeForPostHog = (discount) => {
  let type = 'unknown';
  if (discount?.type === DISCOUNT_TYPE.BOGO) {
    type = 'bogo';
  } else if (discount?.type === DISCOUNT_TYPE.SPECIFIC_ITEMS) {
    type = 'item_level';
  } else if (
    discount?.type === DISCOUNT_TYPE.WHOLE_CART &&
    discount?.rate?.type === DISCOUNT_TYPE.PERCENTAGE
  ) {
    type = 'percentage_off';
  } else if (
    discount?.type === DISCOUNT_TYPE.WHOLE_CART &&
    discount?.rate?.type === DISCOUNT_TYPE.FIXED
  ) {
    type = 'fixed_amount';
  } else {
    type = 'unknown';
  }

  return type;
};
